import { shallowMount } from "@vue/test-utils";
import OfferElement from "@/components/core/OfferElement";

describe("OfferElement component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(OfferElement);
  });

  it("Renders del component OfferElement", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
